import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { IonButton } from '@ionic/angular';

@Component({
  selector: 'bepatient-onboarding-password-popup',
  templateUrl: './onboarding-password-popup.component.html',
  styleUrls: ['./onboarding-password-popup.component.scss'],
  standalone: false
})
export class OnboardingPasswordPopupComponent implements OnInit, AfterViewInit {
  @Input() email: string;
  @Input() color: string;
  @Input() buttonLabel: string;
  @Output() change = new EventEmitter<string>();
  @ViewChild(IonButton, { read: ElementRef, static: true })
  buttonElement: ElementRef;
  resetForm: UntypedFormGroup;

  ngOnInit(): void {
    this.resetForm = new UntypedFormGroup({
      loginId: new UntypedFormControl(this.email, Validators.required)
    });
  }

  ngAfterViewInit(): void {
    const style = this.buttonElement.nativeElement.style;
    style.setProperty('--background', this.color);
    style.setProperty('--background-activated', this.color);
    style.setProperty('--background-focused', this.color);
  }

  changePassword(value): void {
    this.change.emit(value.loginId);
  }
}
